"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
var _utils = require("../utils");
var _shared = require("./shared");
var _functional = require("../utils/functional");
var _router = require("../utils/router");
var _icon = _interopRequireDefault(require("../icon"));
// Types

var _use = (0, _utils.use)('cell'),
  sfc = _use[0],
  bem = _use[1];
function Cell(h, props, slots, ctx) {
  var disabled = props.disabled,
    icon = props.icon,
    zziconfont = props.zziconfont,
    classPrefix = props.classPrefix,
    title = props.title,
    titleTag = props.titleTag,
    titleInfo = props.titleInfo,
    label = props.label,
    value = props.value,
    isLink = props.isLink,
    arrowDirection = props.arrowDirection,
    extra = props.extra,
    extraTag = props.extraTag,
    extraDot = props.extraDot,
    required = props.required;
  var showTitle = slots.title || (0, _utils.isDef)(title);
  var showLabel = slots.label || (0, _utils.isDef)(label);
  var showValue = slots.value || slots.default || value;
  var onTitleClick = function onTitleClick(event) {
    if (disabled) return;
    if (titleInfo) {
      event.stopPropagation();
      (0, _functional.emit)(ctx, 'click-title', event);
    }
  };
  var Label = showLabel && h("div", {
    "class": [bem('label'), props.labelClass]
  }, [slots.label ? slots.label() : label]);
  // console.log('titleStyle', props, props.titleStyle)
  var Title = showTitle && h("div", {
    "class": [bem('title'), props.titleClass],
    "style": props.titleStyle
  }, [h("div", {
    "class": [bem('title-text', required && 'required')]
  }, [slots.title ? slots.title() : h("span", [title]), titleTag && h("span", {
    "class": [bem('title-tag'), 'z-hairline--surround']
  }, [titleTag]), titleInfo && h(_icon.default, {
    "attrs": {
      "name": "info",
      "classPrefix": "zziconfont"
    },
    "class": bem('title-icon'),
    "on": {
      "click": onTitleClick
    }
  })]), Label]);
  var Value = h("div", {
    "class": [bem('value', {
      alone: !showTitle
    }), props.valueClass, 'z-ellipsis']
  }, [slots.value ? slots.value() : slots.default ? slots.default() : h("span", [value])]);
  var Extra = h("div", {
    "class": [bem('extra', {
      alone: !showTitle
    }), props.extraClass]
  }, [extraDot && h("span", {
    "class": bem('extra-dot')
  }, [extraDot]), extraTag && h("span", {
    "class": bem('extra-tag')
  }, [extraTag]), slots.extra ? slots.extra() : h("span", [extra])]);
  var LeftIcon = slots.icon ? slots.icon() : icon && h(_icon.default, {
    "class": bem('left-icon'),
    "attrs": {
      "name": icon,
      "classPrefix": classPrefix || (zziconfont ? 'zziconfont' : undefined)
    }
  });
  var rightIconSlot = slots['right-icon'];
  var RightIcon = rightIconSlot ? rightIconSlot() : isLink && h(_icon.default, {
    "class": bem('right-icon'),
    "attrs": {
      "classPrefix": arrowDirection ? 'z-icon' : 'zziconfont',
      "name": arrowDirection ? "arrow-" + arrowDirection : 'arrow-right'
    }
  });
  var onClick = function onClick(event) {
    if (disabled) return;
    (0, _functional.emit)(ctx, 'click', event);
    (0, _router.functionalRoute)(ctx);
  };
  var classes = {
    center: props.center,
    disabled: props.disabled,
    borderless: !props.border,
    clickable: !props.disabled && (isLink || props.clickable)
  };
  return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
    "class": bem(classes),
    "on": {
      "click": onClick
    }
  }, (0, _functional.inherit)(ctx)]), [LeftIcon, Title, showValue ? Value : Extra, RightIcon]);
}
Cell.props = Object.assign({}, _shared.cellProps, _router.routeProps, {
  zziconfont: Boolean,
  // 兼容旧写法
  classPrefix: String,
  disabled: Boolean,
  clickable: Boolean,
  titleTag: String,
  extraTag: String,
  extraDot: Boolean,
  titleInfo: Boolean,
  titleStyle: Object,
  arrowDirection: String,
  required: Boolean
});
var _default = sfc(Cell);
exports.default = _default;